
import { ref } from '../../_snowpack/pkg/vue.js';
import { useQuery } from '../../_snowpack/pkg/@vue/apollo-composable.js';
import { PAST_LAUNCHES } from '../graphql/queries.js';
import LaunchCard from './LaunchCard.vue.js';

const defaultExport = {
  components: {
    LaunchCard
  },
  setup() {
    const missionAmount = ref(3);

    if (localStorage.limit) {
      missionAmount.value = parseInt(localStorage.limit);
    }

    const { result, loading, error } = useQuery(PAST_LAUNCHES, {
      limit: missionAmount.value
    });

    return { result, loading, error };
  }
};

import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "../../_snowpack/pkg/vue.js"

const _hoisted_1 = { class: "apollo container-lg" }
const _hoisted_2 = {
  key: 0,
  class: "text-center display-6 text-muted"
}
const _hoisted_3 = {
  key: 1,
  class: "text-center text-danger"
}
const _hoisted_4 = {
  key: 2,
  class: "row row-cols-1 row-cols-md-2 row-cols-xl-3 g-3 mx-2"
}

export function render(_ctx, _cache) {
  const _component_LaunchCard = _resolveComponent("LaunchCard")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Loading... "))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Error: " + _toDisplayString(_ctx.error.message), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.launchesPast, (launch) => {
              return (_openBlock(), _createElementBlock("div", {
                key: launch.id,
                class: "col"
              }, [
                _createVNode(_component_LaunchCard, {
                  launch: launch,
                  style: {"cursor":"pointer"}
                }, null, 8, ["launch"])
              ]))
            }), 128))
          ]))
  ]))
};

defaultExport.render = render;

export default defaultExport;